import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import {
  CasRHFTextField,
  CasRHFAutocompleteAsync,
  CasStackRow,
} from 'src/compass/shared/components';
import { CasRHFRiskManagerSelect } from 'src/compass/application/general/components/CasRiskManagerSelect';
import { CasRHFRiskWithSalesManagerSelect } from 'src/compass/application/general/components/CasRiskWithSalesManagerSelect';
import { CasRHFSourceSelect } from 'src/compass/application/general/components/CasSourceSelect';
import { Terms } from 'src/compass/shared/util/terms';

export default function CustomerFormFields() {
  const triggerFields = ['sourceEmployeeId', 'sourceId'];

  const { control, trigger } = useFormContext();

  const [sourceEmployeeId, sourceId] = useWatch({
    control,
    name: triggerFields,
  });

  useEffect(() => {
    if (sourceEmployeeId !== undefined && sourceId !== undefined) trigger(triggerFields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sourceEmployeeId, sourceId, trigger]);

  return (
    <>
      <CasRHFTextField name="name" label="Name" />
      <CasRHFAutocompleteAsync
        url="Hubspot/CompaniesAndContacts/List"
        name="crmCompositeObj"
        label={`${Terms.CRM.label} Contact/Company`}
      />
      <CasRHFRiskManagerSelect name="rmcOfRecordEmployeeId" label="RMC of Record" />
      <CasStackRow gapSize="none">
        <CasRHFRiskWithSalesManagerSelect
          includeNoneOption
          name="sourceEmployeeId"
          label="Source Employee"
        />
        <CasRHFSourceSelect name="sourceId" label="Type" includeNoneOption />
      </CasStackRow>
      { /* <CasRHFTextField name="grouping" label="Grouping" /> */ }
    </>
  );
}
